import { useContext } from "react";
import TrackerContext from "../app/TrackerContext/index.js";
export default function () {
    return useContext(TrackerContext);
}
